import React, {useEffect,useState} from 'react'
import {FormField,Select,Text} from 'grommet'
import {Package} from 'grommet-icons'
import {APIRequest} from '../components/utils/shared/requests'

function CommoditiesDropdown(props) {
    const [commodity, setCommodity] = useState({code: '', name: 'Select Commodity', display_name: '', description: ''});
    const [commodities, setCommodities] = useState([]);
    const [defaultOptions,setDefaultOptions] = useState([])
        useEffect(() => {     
          const url = (props.user === 'SuperAdmin' ? '/commodities' : "/get_lab_commodities")
          APIRequest(url).then(result => {
            setCommodities(result)
            setDefaultOptions(result)
            if (props.props.props.user === 'Agent'){
              setCommodity(result[0])
            }
          })
          if (props.commodity !== {}){
            setCommodity(props.commodity)
          } 
          
         },[]);
  return ( 
    <FormField required name="commodity" label={<Text size='small'>Commodity</Text>}  margin='small'>
      <Select
       onSearch={(text) => {
                  // The line below escapes regular expression special characters:
                  // [ \ ^ $ . | ? * + ( )
                  const escapedText = text.replace(/[-\\^$*+?.()|[\]{}]/g, '\\$&');
        
                  // Create the regular expression with modified value which
                  // handles escaping special characters. Without escaping special
                  // characters, errors will appear in the console
                  const exp = new RegExp(escapedText, 'i');
                  setCommodities(defaultOptions.filter((o) => exp.test(o.display_name)));
                }}
       size='small' icon={<Package />} name='commodity' placeholder={'Select Commodity'} options={commodities} value={commodity} labelKey="display_name" valueKey="id" onChange={({ option }) => {setCommodity(option)}}/>
    </FormField>
  )
}

export default CommoditiesDropdown
